import L from 'leaflet';

/**
 * Draw the map
 * @param {number} zoom -Number of the zoom
 * @returns Normal tile layer.
 */
const getNormalTileLayer = (zoom) => {
    return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>',
    });
};

/**
 * @returns Detailed tile layer (with relief).
 */
const getDetailedTileLayer = () => {
    return L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
        attribution:
            'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
    });
};

/**
 * @returns Satellite tile layer (with relief).
 */
 const getGoogleHybridTileLayer = () => {
    return L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
        subdomains:['mt0','mt1','mt2','mt3']   
    // attribution:
         //   'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
    });

};

export { getNormalTileLayer, getDetailedTileLayer, getGoogleHybridTileLayer };
